/* Login */
export const AUTH = 'AUTH';
export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const LOGOUT = 'LOGOUT';
export const LOGOUT_START = 'LOGOUT_START';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAIL = 'LOGOUT_FAIL';
export const STORE_CAPABILITIES = 'STORE_CAPABILITIES';
export const STORE_EXTENDED_ATTRIBUTES = 'STORE_EXTENDED_ATTRIBUTES';

/* IdP */
export const GET_IDP_METADATA = 'GET_IDP_METADATA';
export const GET_IDP_METADATA_START = 'GET_IDP_METADATA_START';
export const GET_IDP_METADATA_SUCCESS = 'GET_IDP_METADATA_SUCCESS';
export const GET_IDP_METADATA_FAIL = 'GET_IDP_METADATA_FAIL';
export const HIDE_IDP_METADATA_POPUP = 'HIDE_IDP_METADATA_POPUP';
export const SHOW_IDP_METADATA_POPUP = 'SHOW_IDP_METADATA_POPUS';
export const GET_WORKFLOWS_SUCCESS = 'GET_WORKFLOWS_SUCCESS';
export const GET_WORKFLOWS_FAIL = 'GET_WORKFLOWS_FAIL';
export const GET_PREDEFINED_OIDC_ACR_WORKFLOW_SUCCESS = 'GET_PREDEFINED_OIDC_ACR_WORKFLOW_SUCCESS';
export const GET_PREDEFINED_OIDC_ACR_WORKFLOW_FAIL = 'GET_PREDEFINED_OIDC_ACR_WORKFLOW_FAIL';

/* Service Provider */
export const ADD_SP = 'ADD_SP';
export const ADD_SP_START = 'ADD_SP_START';
export const ADD_SP_SUCCESS = 'ADD_SP_SUCCESS';
export const ADD_SP_FAIL = 'ADD_SP_FAIL';
export const CHANGE_SELECTED_IMPORT_OPTION = 'CHANGE_SELECTED_IMPORT_OPTION';
export const GET_SP_LIST = 'GET_SP_LIST';
export const GET_SP_LIST_START = 'GET_SP_LIST_START';
export const GET_SP_LIST_SUCCESS = 'GET_SP_LIST_SUCCESS';
export const GET_SP_LIST_FAIL = 'GET_SP_LIST_FAIL';
export const GET_SP = 'GET_SP';
export const GET_SP_START = 'GET_SP_START';
export const GET_SP_SUCCESS = 'GET_SP_SUCCESS';
export const GET_SP_FAIL = 'GET_SP_FAIL';
export const DELETE_SP = 'DELETE_SP';
export const DELETE_SP_START = 'DELETE_SP_START';
export const DELETE_SP_SUCCESS = 'DELETE_SP_SUCCESS';
export const DELETE_SP_FAIL = 'DELETE_SP_FAIL';
export const UPDATE_APPLICATION = 'UPDATE_APPLICATION';
export const UPDATE_APPLICATION_START = 'UPDATE_APPLICATION_START';
export const UPDATE_APPLICATION_SUCCESS = 'UPDATE_APPLICATION_SUCCESS';
export const UPDATE_APPLICATION_FAIL = 'UPDATE_APPLICATION_FAIL';
export const CANCEL_ADD_APPLICATION = "CANCEL_ADD_APPLICATION";
export const UPDATE_DOWNLOAD_URL = 'UPDATE_DOWNLOAD_URL';
export const SHOW_IMPORT_MODAL = 'SHOW_IMPORT_MODAL';
export const HIDE_IMPORT_MODAL = 'HIDE_IMPORT_MODAL';
export const SHOW_ALL_METADATA_MODAL = 'SHOW_ALL_METADATA_MODAL';
export const HIDE_ALL_METADATA_MODAL = 'HIDE_ALL_METADATA_MODAL';
export const SHOW_EXPIRED_METADATA_CERTIFICATE_MODAL = 'SHOW_EXPIRED_METADATA_CERTIFICATE_MODAL';
export const HIDE_EXPIRED_METADATA_CERTIFICATE_MODAL = 'HIDE_EXPIRED_METADATA_CERTIFICATE_MODAL';
export const OPEN_HELP_DOC_PAGE = "OPEN_HELP_DOC_PAGE";
export const SHOW_START_USING_NEW_IDP_CERTIFICATE_MODAL = 'SHOW_START_USING_NEW_IDP_CERTIFICATE_MODAL';
export const HIDE_START_USING_NEW_IDP_CERTIFICATE_MODAL = 'HIDE_START_USING_NEW_IDP_CERTIFICATE_MODAL';
export const START_USING_NEW_IDP_CERTIFICATE_SUCCESS = "START_USING_NEW_IDP_CERTIFICATE_SUCCESS;"
export const UPDATE_IS_PUBLIC_CLIENT = "UPDATE_IS_PUBLIC_CLIENT";
export const ADD_CONFIGURABLE_WORKFLOW = "ADD_CONFIGURABLE_WORKFLOW";
export const UPDATE_CONFIGURABLE_WORKFLOW = "UPDATE_CONFIGURABLE_WORKFLOW";
export const DELETE_CONFIGURABLE_WORKFLOW = "DELETE_CONFIGURABLE_WORKFLOW";

/* SP Application names */
export const UPDATE_APP_NAME = "UPDATE_APP_NAME";
export const UPDATE_USER_FRIENDLY_NAME = "UPDATE_USER_FRIENDLY_NAME";

/* Default NameId */
export const UPDATE_DEFAULT_NAME_ID = "UPDATE_DEFAULT_NAME_ID";

/* Unspecified NameId Format Attribute*/
export const UPDATE_UNSPECIFIED_NAME_ID_FORMAT_ATTRIBUTE = "UPDATE_UNSPECIFIED_NAME_ID_FORMAT_ATTRIBUTE";

/* SP User Attributes */
export const DELETE_USER_ATTRIBUTE = 'DELETE_USER_ATTRIBUTE';
export const ADD_USER_ATTRIBUTE = 'ADD_USER_ATTRIBUTE';
export const UPDATE_USER_ATTRIBUTES = 'UPDATE_USER_ATTRIBUTE';

/* SP User Group Attributes */
export const DELETE_USER_GROUP_ATTRIBUTE = 'DELETE_USER_GROUP_ATTRIBUTE';
export const ADD_USER_GROUP_ATTRIBUTE = 'ADD_USER_GROUP_ATTRIBUTE';
export const UPDATE_USER_GROUP_ATTRIBUTES = 'UPDATE_USER_GROUP_ATTRIBUTES';

export const RECOVER_APPLICATION = 'RECOVER_APPLICATION';
export const REPLACE_APPLICATION = 'REPLACE_APPLICATION';

/* Parse XML from Url */
export const PARSE_FROM_URL = 'PARSE_FROM_URL';
export const PARSE_FROM_URL_START = 'PARSE_FROM_URL_START';
export const PARSE_FROM_URL_SUCCESS = 'PARSE_FROM_URL_SUCCESS';
export const PARSE_FROM_URL_FAIL = 'PARSE_FROM_URL_FAIL';
export const CLEAR_IMPORT_URL = 'CLEAR_IMPORT_URL';

/* Parse XML from file*/
export const PARSE_FROM_XML = 'PARSE_FROM_XML';
export const PARSE_FROM_XML_START = 'PARSE_FROM_XML_START';
export const PARSE_FROM_XML_SUCCESS = 'PARSE_FROM_XML_SUCCESS';
export const PARSE_FROM_XML_FAIL = 'PARSE_FROM_XML_FAIL';
export const CLEAR_ERROR_MESSAGE = "CLEAR_ERROR_MESSAGE";

export const GET_APPLICATION = 'GET_APPLICATION';
export const GET_APPLICATION_START = 'GET_APPLICATION_START';
export const GET_SAML_APPLICATION_SUCCESS = 'GET_SAML_APPLICATION_SUCCESS';
export const GET_OIDC_APPLICATION_SUCCESS = 'GET_OIDC_APPLICATION_SUCCESS';
export const GET_WS_FED_APPLICATION_SUCCESS = 'GET_WS_FED_APPLICATION_SUCCESS';
export const GET_APPLICATION_FAIL = 'GET_APPLICATION_FAIL';
export const SET_APPLICATION_ID = 'SET_APPLICATION_ID';

/* Customization */
export const SAVE_CUSTOMIZATION_START = 'SAVE_CUSTOMIZATION_START';
export const SAVE_CUSTOMIZATION_SUCCESS = 'SAVE_CUSTOMIZATION_SUCCESS';
export const SAVE_CUSTOMIZATION_FAIL = 'SAVE_CUSTOMIZATION_FAIL';
export const GET_CUSTOMIZATION_START = 'GET_CUSTOMIZATION_START';
export const GET_CUSTOMIZATION_SUCCESS = 'GET_CUSTOMIZATION_SUCCESS';
export const GET_CUSTOMIZATION_FAIL = 'GET_CUSTOMIZATION_FAIL';
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES';
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';

/* Add OIDC app*/
export const ADD_OIDC_APP_START = 'ADD_OIDC_APP_START';
export const ADD_OIDC_APP_SUCCESS = 'ADD_OIDC_APP_SUCCESS';
export const ADD_OIDC_APP_FAIL = 'ADD_OIDC_APP_FAIL';

/* OIDC Redirect URIs */
export const  DELETE_OIDC_REDIRECT_URI = 'DELETE_OIDC_REDIRECT_URI';
export const  ADD_OIDC_REDIRECT_URI = 'ADD_OIDC_REDIRECT_URI';
export const  UPDATE_OIDC_REDIRECT_URI = 'UPDATE_OIDC_REDIRECT_URI';

/* Generate OIDC client credentials*/
export const GENERATE_OIDC_CLIENT_CREDENTIALS_START = 'GENERATE_OIDC_CLIENT_CREDENTIALS_START';
export const GENERATE_OIDC_CLIENT_CREDENTIALS_SUCCESS = 'GENERATE_OIDC_CLIENT_CREDENTIALS_SUCCESS';
export const GENERATE_OIDC_CLIENT_CREDENTIALS_FAIL = 'GENERATE_OIDC_CLIENT_CREDENTIALS_FAIL';

/* OIDC IdP */
export const GET_OIDC_IDP_METADATA_START = 'GET_OIDC_IDP_METADATA_START';
export const GET_OIDC_IDP_METADATA_SUCCESS = 'GET_OIDC_IDP_METADATA_SUCCESS';
export const GET_OIDC_IDP_METADATA_FAIL = 'GET_OIDC_IDP_METADATA_FAIL';
export const HIDE_OIDC_IDP_METADATA_POPUP = 'HIDE_OIDC_IDP_METADATA_POPUP';
export const SHOW_OIDC_IDP_METADATA_POPUP = 'SHOW_OIDC_IDP_METADATA_POPUP';

/* Add WS-Federation app*/
export const ADD_WS_FED_APP_START = 'ADD_WS_FED_APP_START';
export const ADD_WS_FED_APP_SUCCESS = 'ADD_WS_FED_APP_SUCCESS';
export const ADD_WS_FED_APP_FAIL = 'ADD_WS_FED_APP_FAIL';

/* WS-Federation Redirect URIs */
export const  UPDATE_WS_FED_REDIRECT_URI = 'UPDATE_WS_FED_REDIRECT_URI';

/* WS-Federation IdP */
export const HIDE_WS_FED_IDP_METADATA_POPUP = 'HIDE_WS_FED_IDP_METADATA_POPUP';
export const SHOW_WS_FED_IDP_METADATA_POPUP = 'SHOW_WS_FED_IDP_METADATA_POPUP';

/* Azure AD */
export const ADD_AZURE_AD_START = 'ADD_AZURE_AD_START';
export const ADD_AZURE_AD_SUCCESS = 'ADD_AZURE_AD_SUCCESS';
export const ADD_AZURE_AD_FAIL = 'ADD_AZURE_AD_FAIL';

export const EDIT_AZURE_AD = 'EDIT_AZURE_AD';

export const DELETE_AZURE_AD_START = 'DELETE_AZURE_AD_START';
export const DELETE_AZURE_AD_SUCCESS = 'DELETE_AZURE_AD_SUCCESS';
export const DELETE_AZURE_AD_FAIL = 'DELETE_AZURE_AD_FAIL';

export const GET_AZURE_AD_LIST_START = 'GET_AZURE_AD_LIST_START';
export const GET_AZURE_AD_LIST_SUCCESS = 'GET_AZURE_AD_LIST_SUCCESS';
export const GET_AZURE_AD_LIST_FAIL = 'GET_AZURE_AD_LIST_FAIL';

export const GET_AZURE_AD_JSON_START = 'GET_AZURE_AD_JSON_START';
export const GET_AZURE_AD_JSON_SUCCESS = 'GET_AZURE_AD_JSON_SUCCESS';
export const GET_AZURE_AD_JSON_FAIL = 'GET_AZURE_AD_LIST_FAIL';

/* OIDC custom claims*/
export const ADD_SCOPE = 'ADD_SCOPE';
export const UPDATE_SCOPE = 'UPDATE_SCOPE';
export const DELETE_SCOPE = 'DELETE_SCOPE';

/* OIDC EntraId EAM */
export const UPDATE_ENTRA_ID_TENANT_ID = "UPDATE_ENTRA_ID_TENANT_ID";
export const UPDATE_OIDC_ENTRA_ID_EAM_REDIRECT_URI = 'UPDATE_OIDC_ENTRA_ID_EAM_REDIRECT_URI';
export const REDIRECT_TO_WORKFLOW_POLICY_PAGE = "REDIRECT_TO_WORKFLOW_POLICY_PAGE";
